import React from 'react';
import { FilterMenuContent } from './FilterMenuContent';
import isEqual from 'lodash/isEqual';
import debounce from 'lodash/debounce';

const DEFAULT_DELAY = 1000;

export class FilterMenuContentDebounced extends React.Component {
	state = {
		localSelected: this.props.selected || [],
	};

	componentDidUpdate(prevProps) {
		const { selected } = this.props;

		if (selected && !isEqual(prevProps.selected, selected)) {
			this.setState({ localSelected: selected });
		}
	}

	debouncedChange = debounce(
		this.props.onChange,
		this.props.delay != null ? this.props.delay : DEFAULT_DELAY
	);

	handleChange = selected => {
		this.setState({ localSelected: selected }, () => {
			const { localSelected } = this.state;

			this.debouncedChange(localSelected);
		});
	};

	render() {
		const { localSelected } = this.state;

		return (
			<FilterMenuContent
				{...this.props}
				selected={localSelected}
				onChange={this.handleChange}
			/>
		);
	}
}
